import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

const AddLessonsTo1on1PlanMutation = gql`
  mutation addLessonsTo1on1Plan(
    $planId: String!
    $teacherId: String!
    $slots: [AddLessonTo1on1PlanSlotInput!]!
  ) {
    addLessonsTo1on1Plan(planId: $planId, teacherId: $teacherId, slots: $slots)
  }
`;

export function useAddLessonsTo1on1Plan() {
  const [mutate, { loading }] = useMutation<{ addLessonsTo1on1Plan: string }>(
    AddLessonsTo1on1PlanMutation,
  );

  const addLessons = useCallback(
    async (params: {
      planId: string;
      teacherId: string;
      slots: Array<{ startUtc: string; endUtc: string }>;
    }): Promise<string> => {
      const result = await mutate({ variables: params });
      return result.data!.addLessonsTo1on1Plan;
    },
    [mutate],
  );

  return { addLessons, loading };
}
